var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9229 16.8335V8.83352C21.9225 8.48279 21.8299 8.13833 21.6544 7.83468C21.4789 7.53104 21.2266 7.27888 20.9229 7.10352L13.9229 3.10352C13.6188 2.92798 13.2739 2.83557 12.9229 2.83557C12.5718 2.83557 12.2269 2.92798 11.9229 3.10352L4.92285 7.10352C4.61911 7.27888 4.36683 7.53104 4.19131 7.83468C4.01579 8.13833 3.92321 8.48279 3.92285 8.83352V16.8335C3.92321 17.1842 4.01579 17.5287 4.19131 17.8324C4.36683 18.136 4.61911 18.3882 4.92285 18.5635L11.9229 22.5635C12.2269 22.7391 12.5718 22.8315 12.9229 22.8315C13.2739 22.8315 13.6188 22.7391 13.9229 22.5635L20.9229 18.5635C21.2266 18.3882 21.4789 18.136 21.6544 17.8324C21.8299 17.5287 21.9225 17.1842 21.9229 16.8335Z",
    stroke: "#3466E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19238 7.79346L12.9224 12.8435L21.6524 7.79346",
    stroke: "#3466E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9229 22.9135V12.8335",
    stroke: "#3466E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/Hexagon.c80d4dbddfab1179b8804c68b11db169.svg";
export { ForwardRef as ReactComponent };